import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useTranslation } from 'react-i18next';

import { TOKENS } from '../worktimeLib';

/**
 * Shown when a clock-in/switch returned state_coupling.action === 'needs_reopen_confirmation'
 * (the mechanic clocked into a completed/picked-up order — the session WAS created and time is
 * tracked, but the order did NOT auto-reopen). Offers to reopen via the canonical state change.
 */
export default function ReopenConfirmDialog({ open, maintenanceState, onConfirm, onClose, busy }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: '10px',
            backgroundColor: TOKENS.amberSoft,
            color: TOKENS.amber,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <WarningAmberIcon fontSize="small" />
        </Box>
        {t('worktime.reopen.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('worktime.reopen.body', {
            state: t(`status.${maintenanceState}`),
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2.5, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" disabled={busy}>
          {t('worktime.reopen.keepClosed')}
        </Button>
        <Button onClick={onConfirm} variant="contained" disabled={busy}>
          {t('worktime.reopen.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
